import React from 'react'
import { useRouter } from 'next/router'
import { Container, Typography, Button } from '@evocolabs/orkaui'
import { Stack, SxProps } from '@mui/material'
import { ResponsiveBg, getBackgroundStyles } from '../HomePage/utils'
import Banner from '../HomePage/Banner'
import { SectionTitle } from '../title'
import { CardData } from './PreSales'
import { cacheClick } from '@/pages/Home'
import { getImage } from '@/src/utils/media'

const SRC_PATH = '/website/orkaCare'
const data: CardData = {
  title: 'Try OrkaCare with 45-Day Risk-Free Trial',
  content: `The full OrkaCare service is included in our free trial period.
  Try and see for yourself. You've got nothing to lose.`,
  src: '45DayTrail.jpg',
  btnText: 'Get Started',
  path: '/SurveyPage',
  buttonId: 'survey'
}

const mediaStyles = {
  pc: {
    src: getImage(data.src, 'PC', SRC_PATH),
    coverRatio: 800 / 1600
  },
  mobile: {
    src: getImage(data.src, 'Mobile', SRC_PATH),
    coverRatio: 800 / 395
  },
  tablet: { src: getImage(data.src, 'Tablet', SRC_PATH), coverRatio: 834 / 955 }
}

const getResponsiveStyles = ({
  pc,
  mobile,
  tablet
}: ResponsiveBg): SxProps => ({
  backgroundSize: 'cover',
  ...getBackgroundStyles(mobile),
  backgroundPositionY: `${mobile.coverRatio * 100}%`,

  '@media (min-width: 1024px)': {
    ...getBackgroundStyles(pc),
    backgroundPositionY: '0%',
    maxHeight: '80vh',
    minHeight: '480px'
  },

  '@media (min-width: 600px) and (max-width: 1024px)': !!tablet && {
    ...getBackgroundStyles(tablet),
    backgroundPositionY: `${tablet.coverRatio * 100}%`
  }
})

const Recommendation = () => {
  const router = useRouter()
  const { title, content, btnText, path } = data

  return (
    <Banner
      buttonId="orka-care-recommendation"
      bgStyles={getResponsiveStyles(mediaStyles)}
    >
      <Container sx={{ height: '100%', paddingY: { xs: 8, dl: 10 } }}>
        <Stack
          width={{ xs: '100%', dl: '55%' }}
          height="100%"
          justifyContent={{ xs: 'flex-start', dl: 'center' }}
        >
          <SectionTitle textAlign="left">{title}</SectionTitle>
          <Stack>
            <Typography
              variant="body2"
              color="black"
              mt={2}
              mb={{ xs: 3, sm: 5 }}
            >
              {content}
            </Typography>
            <Button
              variant="primary"
              size="large"
              onClick={() => {
                cacheClick('orka-care-recommendation')
                router.push(path)
              }}
              id={`orka-care-page-recommendation-section-${btnText}`}
            >
              {btnText}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Banner>
  )
}

export default Recommendation
